var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconProfileMono(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.8125 7.38095C8.14143 7.38095 9.21875 6.28831 9.21875 4.94048C9.21875 3.59264 8.14143 2.5 6.8125 2.5C5.48356 2.5 4.40625 3.59264 4.40625 4.94048C4.40625 6.28831 5.48356 7.38095 6.8125 7.38095Z",
    fill: "#8F96A9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.625 10.9036C11.625 11.7351 9.46783 12.75 6.81248 12.75C4.15714 12.75 2 11.6459 2 10.9036C2 9.87934 4.15714 8.35712 6.81248 8.35712C9.46783 8.35712 11.625 9.87934 11.625 10.9036Z",
    fill: "#8F96A9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProfileMono);
export default __webpack_public_path__ + "static/media/icon_profile_mono.c774f3469f90ad25af2a9ee5ca3c3a7e.svg";
export { ForwardRef as ReactComponent };